import { TableIdEnum } from '@configs/table'

/** 关键词展示形式 枚举值 */
export enum KeyWordTypeEnum {
  /** 按时间 */
  Time = 'time',
  /** 按分组 */
  Group = 'group',
}

/** audio中进度条左侧的长度 - 固定的，不会随着audio容器的宽度变化 */
export const sliderLeftWidth = 132

/** audio中进度条右侧的长度 - 固定的，不会随着audio容器的宽度变化 */
export const sliderRightWidth = 90

/** 展示在音频条上的 TAB 宽度  */
export const tabWidth = 76

/** 关键词 TAG OPTIONS */
export const keyWordTypeOptions = [
  { label: '按时间', value: KeyWordTypeEnum.Time },
  { label: '按分组', value: KeyWordTypeEnum.Group },
]

/** 页面类型枚举值 */
export enum PAGE_TYPE_ENUM {
  /** T3C通话记录 */
  T3C = 'tccc',
  /** 腾会通话记录 */
  MEETING = 'meeting',
}

/** 页面类型MAP */
export const PAGE_TYPE_MAP = {
  /** T3C通话记录 */
  [PAGE_TYPE_ENUM.T3C]: TableIdEnum.TCCC_CALL_RECORD,
  /** 腾会通话记录 */
  [PAGE_TYPE_ENUM.MEETING]: TableIdEnum.MEETING_CALL_RECORD,
}
